import {Pipe, PipeTransform} from "@angular/core";
import {FilterItem} from "@components";

@Pipe({
  name: 'selectedFilterLabel',
  standalone: false
})
export class SelectedFilterLabelPipe implements PipeTransform {
  transform(items: FilterItem[], t: (key: string) => string): string | undefined {
    const selected = items.filter(i => i.selected);
    if (!selected.length) return undefined;
    return selected
      .map(i => i.labelKey ? t(i.labelKey) : (i.label ?? ''))
      .join(', ');
  }
}
